import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = {
    panelClass: { type: String, default: "hidden" },
    storageKey: { type: String, default: "" },
    urlParam: { type: String, default: "" },
  };

  connect() {
    const saved = this._resolveSavedName();
    const index =
      saved !== null
        ? this.tabTargets.findIndex((t) => t.dataset.name === saved)
        : this.tabTargets.findIndex((t) => t.getAttribute("aria-selected") === "true");
    this.showIndex(index >= 0 ? index : 0);
  }

  show(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    this.showIndex(index);
  }

  showIndex(index) {
    const name = this.tabTargets[index]?.dataset.name;
    this.tabTargets.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute("aria-selected", active.toString());
      tab.classList.toggle("tab-active", active);
    });
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle(this.panelClassValue, i !== index);
    });
    if (this.storageKeyValue && name) {
      try {
        localStorage.setItem(this.storageKeyValue, name);
      } catch {}
    }
  }

  _resolveSavedName() {
    if (this.urlParamValue) {
      const param = new URLSearchParams(window.location.search).get(this.urlParamValue);
      if (param) return param;
    }
    if (this.storageKeyValue) {
      try {
        return localStorage.getItem(this.storageKeyValue);
      } catch {}
    }
    return null;
  }
}
